import gql from 'graphql-tag';

export default gql`
  mutation($publicationUrl: URI!, $suggestionsListId: ID!, $keyword: String!) {
    addKeywordSuggestion(
      input: {
        publicationUrl: $publicationUrl
        suggestionsListId: $suggestionsListId
        libraryComment: ""
        keyword: $keyword
      }
    ) {
      code
    }
  }
`;
